
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/business-operations",
      function () {
        return require("private-next-pages/business-operations.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/business-operations"])
      });
    }
  